import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import { getApplicationByNumber } from 'api';
import { useQuery } from 'hooks/useQuery';
import LoadableLoading from 'components/LoadableLoading';
import { getApplicationExecutor, getPropertyInfo, getUserRights, loadConclusionAct } from './api';

export const path = '/application/:applicationNumber/conclusion-act';

export const getConclusionActPath = (applicationNumber: string, status: string) =>
  `${applicationNumber}/conclusion-act?status=${status}`;

const PageConclusionAct: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();
  const query = useQuery();
  const isNewConclusionAct = query.get('status') === 'new';

  const ConclusionAct = Loadable.Map({
    loader: {
      page: () => import('./page'),
      application: () => getApplicationByNumber(applicationNumber),
      conclusionAct: async () => (isNewConclusionAct ? null : await loadConclusionAct(applicationNumber)),
      executor: () => getApplicationExecutor(applicationNumber),
      rights: () => getUserRights(applicationNumber),
      propertyInfo: () => getPropertyInfo(applicationNumber),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <ConclusionAct {...props} />;
};

export default PageConclusionAct;
